// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1U7HQ","info":"UpdateTermsInfo_info__20yDl"};